import React, { useState, useEffect } from "react";
import "./shareform.css";
import {snackbarContext} from '../../helpers/Snakbar'
import Navbar from "../../helpers/Navbar";
import Stepper from "./Stepper";
import { useDispatch, useSelector } from "react-redux";
import {
  getProfile,
  clearError
} from "../../../redux/reducers/profileSlice";
import { getMyEvents } from "../../../redux/reducers/eventSlice";
import { clearUser, trackShareClick } from "../../../redux/reducers/authSlice";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import { startPayment } from "../../helpers/paymentpopup";
import { TabTitle } from "../../helpers/GeneralFunctions";

const ShareForm = () => {
  TabTitle("Share")
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { user, error: authError } = useSelector(
    (state) => state.auth
  );

  const {
    error: backendError,
    guestLists
  } = useSelector((state) => state.event);

  const { weddingData: data,profileLoaded } = useSelector(
    (state) => state.profile
  );

  const setStateSnackbarContext =React.useContext(snackbarContext);

  const [sharing, setSharing] = useState(false);
     const [paymentLoading, setPaymentLoading] = useState(false);

  const [isDesktop, setIsDesktop] = useState(
    window.innerWidth >= 768
  );

  // =========================================
  // SHARE MODAL STATES
  // =========================================

  const [showShareModal, setShowShareModal] = useState(false);

  // "copy" or "share"
  const [pendingShareAction, setPendingShareAction] =
    useState(null);

  // The actual invitation URL
  const [pendingShareUrl, setPendingShareUrl] =
    useState(null);

       const [showUpgradeModal, setShowUpgradeModal] = useState(false); 
  // =========================================
  // DEMO / INVITE STATUS
  // =========================================

  const now = new Date().getTime();

  const expiryTime = new Date(
    user && user.demoExpiryTime
  ).getTime();

  const isDemoExpired =
    user &&
    user.demoVersion &&
    expiryTime &&
    now > expiryTime;

  // const isInviteExpired =
  //   user && user.inviteTimeExpired;

  // =========================================
  // URL
  // =========================================

  const baseUrl = `https://invite.aamantran.link/${
    user && user.userCode
  }`;

  const shareTitle = "Wedding Invitation";

  // =========================================
  // INVITATION MESSAGE
  // =========================================

//   const buildMessage = () => {

//     return `Hello!

// We cordially invite you along with your family to celebrate the beginning of our new life! ❤️🎊

// 💍 ${data?.groomName} Weds ${data?.brideName}

// 💌 View e-invite:`;

//   };

const buildMessage = () => {
  const coupleNames =
    data?.displayOrder === "brideFirst"
      ? `${data?.brideName} Weds ${data?.groomName}`
      : `${data?.groomName} Weds ${data?.brideName}`;

  return `Hello!

We cordially invite you along with your family to celebrate the beginning of our new life! ❤️🎊

💍 ${coupleNames}

💌 View e-invite:`;
};

  const getInvitationText = (url) => {

    return `${buildMessage()}

${url}`;

  };

 useEffect(() => {
      if (!profileLoaded) return;
  
      if (!data?.theme) {
          setStateSnackbarContext(
              true,
              "Please select Theme",
              "warning"
          );
  
          navigate("/sample-themes");
      }
  }, [profileLoaded, data?.theme, navigate]);


  // =========================================
  // ACTUAL SHARE FUNCTION
  // =========================================

  const handleShare = async (url) => {

    if (sharing) return;

    setSharing(true);

    const shareData = {
      title: shareTitle,
      text: buildMessage(),
      url
    };

    try {

      if (navigator.share) {

        await navigator.share(shareData);

      } else if (navigator.clipboard) {

        await navigator.clipboard.writeText(
          `${shareData.text}\n${shareData.url}`
        );

        setStateSnackbarContext(
          true,
          "Invitation copied successfully.",
          "success"
        );

      } else {

        window.prompt(
          "Copy your invitation:",
          `${shareData.text}\n${shareData.url}`
        );

      }

    } catch (err) {

      // console.log(err);

    } finally {

      setSharing(false);

    }

  };

  // =========================================
  // ACTUAL COPY FUNCTION
  // =========================================

  const handleCopy = async (url) => {

    try {

      await navigator.clipboard.writeText(
        getInvitationText(url)
      );

      setStateSnackbarContext(
        true,
        "Invitation copied successfully.",
        "success"
      );

    } catch (err) {

      // console.log(err);

      setStateSnackbarContext(
        true,
        "Unable to copy invitation.",
        "error"
      );

    }

  };

  // =========================================
  // OPEN SHARE MODAL
  // =========================================

  const openShareModal = (action, url) => {

      // Upgraded users can directly copy/share
  if (!user?.demoVersion) {
    if (action === "copy") {
      handleCopy(url);
    } else if (action === "share") {
      handleShare(url);
    }

    return;
  }

    setPendingShareAction(action);
    setPendingShareUrl(url);

    setShowShareModal(true);

  };

  // =========================================
  // CLOSE SHARE MODAL
  // =========================================

  const closeShareModal = () => {

    setShowShareModal(false);

    setPendingShareAction(null);
    setPendingShareUrl(null);

  };

  // =========================================
  // CONTINUE WITH TRIAL LINK
  // =========================================

  const handleTrialShare = async () => {

    if (!pendingShareUrl || !pendingShareAction) {
      closeShareModal();
      return;
    }

    const url = pendingShareUrl;
    const action = pendingShareAction;

    closeShareModal();

    // Track share milestone only for demo users
  if (user?.demoVersion && !user?.dashboard?.inviteShared) {
    dispatch(trackShareClick());
  }

    // Small delay makes the modal closing feel smoother
    setTimeout(() => {

      if (action === "copy") {

        handleCopy(url);

      } else if (action === "share") {

        handleShare(url);

      }

    }, 100);

  };

  // =========================================
  // UPGRADE
  // =========================================

  const handleUpgradeFromShare = () => {

   setShowUpgradeModal(true)
   setShowShareModal(false);
    /*
      PUT YOUR EXISTING RAZORPAY / UPGRADE FUNCTION HERE.

      Example:

      handleUpgradeClick();

      or

      startPayment(
        user?.userCode,
        navigate,
        setStateSnackbarContext
      );
    */

    // console.log("Start upgrade/payment");

  };

  // =========================================
  // PROFILE + EVENTS
  // =========================================

  useEffect(() => {

    dispatch(getProfile());
    dispatch(getMyEvents());

  }, [dispatch]);

  // =========================================
  // SESSION ERROR
  // =========================================

  useEffect(() => {

    if (
      backendError === "session expired" ||
      backendError === "pls login to acess the resource"
    ) {

      setStateSnackbarContext(
        true,
        "Session expired. Please login again.",
        "error"
      );

      dispatch(clearError());
      dispatch(clearUser());

      navigate("/login");

    } else if (backendError) {

      setStateSnackbarContext(
        true,
        backendError,
        "error"
      );

      dispatch(clearError());

    }

  }, [
    backendError,
    dispatch,
    navigate,
    setStateSnackbarContext
  ]);

  // =========================================
  // AUTH ERROR
  // =========================================

  useEffect(() => {

    if (authError === "session expired") {

      setStateSnackbarContext(
        true,
        "Session expired. Please login again.",
        "error"
      );

      dispatch(clearError());
      dispatch(clearUser());

      navigate("/login");

    }

  }, [
    authError,
    dispatch,
    navigate,
    setStateSnackbarContext
  ]);

  // =========================================
  // RESPONSIVE
  // =========================================

  useEffect(() => {

    const handleResize = () => {

      setIsDesktop(window.innerWidth >= 768);

    };

    window.addEventListener(
      "resize",
      handleResize
    );

    return () => {

      window.removeEventListener(
        "resize",
        handleResize
      );

    };

  }, []);

  // =========================================
  // EXPIRED REDIRECT
  // =========================================

  useEffect(() => {

    if (isDemoExpired) {
      navigate("/");
    }

  }, [isDemoExpired, navigate]);

  // =========================================
  // RENDER
  // =========================================


   const handleUpgradeClick = async () => {
        if (paymentLoading) return;
  
        setPaymentLoading(true);
  
        await startPayment(
      user?.userCode,
      navigate,
      setStateSnackbarContext,
      user?.isAdmin,
      () => setPaymentLoading(false) // callback
    );
    }

    if(user && user.needsDate===true){
  navigate("/")
}

if(user && user.inviteTimeExpired){
 navigate("/")
}

  return (
    <>

      <Navbar />

      <Stepper
        step={4}
        demoVersion={user && user.demoVersion}
      />

      <div className="share-page">

        <h1 className="share-page-heading">
          Share Your Invitation
        </h1>

        <img
          src="/shareimg.png"
          alt="Share Invitation"
          className="share-illustration"
        />

        <p className="share-helper-text">
          Your invitation is ready to be shared.
          Copy the link or share it directly with your guests.
        </p>

        {/* =====================================
            DEFAULT INVITATION
        ===================================== */}

        <div className="default-share-card">

          <span className="default-badge">
            {user?.demoVersion
              ? "My Invitation"
              : "Main Invitation"}
          </span>

          <div className="invite-link-box">
            https://aamantran.link/....
          </div>

          <div className="share-card-actions">

            <button
              className={`copy-btn ${
                isDesktop ? "full-width-btn" : ""
              }`}
              onClick={() =>
                openShareModal("copy", baseUrl)
              }
            >
              {isDesktop
                ? "Copy Invitation"
                : "Copy"}
            </button>

            {!isDesktop && (

              <button
                className="share-btn"
                onClick={() =>
                  openShareModal("share", baseUrl)
                }
              >
                Share
              </button>

            )}

          </div>

        </div>

        {/* =====================================
            GUEST LISTS
        ===================================== */}

        {guestLists && guestLists.length > 0 && (

          <div className="guest-divider">
            Guest Lists
          </div>

        )}

        {guestLists &&
          guestLists.length > 0 &&
          guestLists.map((guestList) => {

            const guestLink =
              `${baseUrl}?group=${guestList.code}`;

            return (

              <div
                className="guest-share-card"
                key={guestList.code}
              >

                <div className="guest-card-top">

                  <span className="guest-name">
                    {guestList.groupname}
                  </span>

                </div>

                <div className="invite-link-box small-link">
                  https://aamantran.link/...
                </div>

                <div className="share-card-actions">

                  <button
                    className={`copy-btn ${
                      isDesktop
                        ? "full-width-btn"
                        : ""
                    }`}
                    onClick={() =>
                      openShareModal(
                        "copy",
                        guestLink
                      )
                    }
                  >
                    {isDesktop
                      ? "Copy Invitation"
                      : "Copy"}
                  </button>

                  {!isDesktop && (

                    <button
                      className="share-btn"
                      onClick={() =>
                        openShareModal(
                          "share",
                          guestLink
                        )
                      }
                    >
                      Share
                    </button>

                  )}

                </div>

              </div>

            );

          })}

      </div>

      <button
        className="share-floating-btn"
        onClick={() => navigate("/")}
      >
        Go to Dashboard →
      </button>


      {/* ==================================================
          SHARE / TRIAL MODAL
      ================================================== */}

      {showShareModal && (

        <div
          className="share-choice-overlay"
          onClick={closeShareModal}
        >

          <div
            className="share-choice-modal"
            onClick={(e) => e.stopPropagation()}
          >

            {/* Close */}

            <button
              className="share-choice-close"
              onClick={closeShareModal}
              aria-label="Close"
            >
              <CloseIcon />
            </button>


            {/* Heading */}

            <h2 className="share-choice-title">
             Your Invitation Is Ready!
            </h2>


            {/* Subheading */}

            <p className="share-choice-subtitle">
              You're currently on a <span style={{color:"orange",fontWeight:"bold"}}>free trial.</span> 
              Choose how you'd like to share
              your invitation.
            </p>


            {/* =====================================
                UPGRADE OPTION
            ===================================== */}

            <div className="share-choice-option upgrade-option">

              <div className="share-option-title">
                ✨ Share without trial expiry
              </div>

              <div className="share-option-description">
                <strong>Upgrade for ₹999</strong>

                <span>
                  One-time payment · No subscription
                </span>
              </div>

              <button
                className="share-upgrade-btn"
                onClick={handleUpgradeFromShare}
              >
                💳 Upgrade & Share →
              </button>

            </div>


            {/* Divider */}

            <div className="share-choice-divider">
              <span></span>
            </div>


            {/* =====================================
                TRIAL OPTION
            ===================================== */}

            <div className="share-choice-option trial-option">

              <div className="share-option-title">
                Share With Expiry
              </div>

              <div className="share-option-description">
                <span style={{fontWeight:"bold",color:"#E58A00"}}>
                  Expires in 3 days
                </span>
              </div>

              <button
                className="share-trial-btn"
                onClick={handleTrialShare}
              >
                🔗 Share
              </button>

            </div>

          </div>

        </div>

      )}

       {showUpgradeModal && (
  <div className="modal-overlay">
    <div className="modal-container">

      {/* Close */}
      <button
        className="modal-close"
        onClick={() => setShowUpgradeModal(false)}
      >
        <CloseIcon className="close-icon" />
      </button>

      {/* Heading */}
      <h2 className="modal-title">
        Upgrade Your Invitation
      </h2>

      {/* Description */}
      <p className="modal-desc">
        Get the complete invitation with all trial restrictions removed.
      </p>

      {/* Benefits */}
      <div className="upgrade-modal-descp">

        {/* Invite Validity */}
        <div className="upgrade-point">
          <span className="benefit-icon">📅</span>

          <p>
            <strong>Invite Validity</strong>

            <span>
              Active from upgrade until 20 days after your wedding date
            </span>
          </p>
        </div>

        {/* Payment */}
        <div className="upgrade-point">
          <span className="benefit-icon">💳</span>

          <p>
            <strong>One-time payment</strong>

            <span>
              ₹999 · No subscription
            </span>
          </p>
        </div>

        {/* Everything Unlocked */}
        <div className="upgrade-point">
          <span className="benefit-icon">✨</span>

          <p>
            <strong>Everything unlocked</strong>

            <span>
              All trial watermarks, limits & restrictions removed
            </span>
          </p>
        </div>

      </div>

      {/* Upgrade Button */}
      <button
        className={`final-upgrade-btn ${
          paymentLoading ? "disabled" : ""
        }`}
        onClick={handleUpgradeClick}
        disabled={paymentLoading}
      >
        {paymentLoading
          ? "Opening payment…"
          : "Upgrade for ₹999 →"}
      </button>

    </div>
  </div>
)}

    </>
  );

};

export default ShareForm;